import {css} from 'emotion'
import { Colors } from '../core';

export const GiftStyle = css({
  'h3': {
    color: 'black',
  },
  '.gift': {
    maxWidth: '100%',
    flexBasis: '100%',
    position: 'relative',
    margin: '2rem 0rem',

    '.push-content': {
      maxWidth: 'none',
      'h3': {
        margin: 0,
      },
      'p': {
        margin: 0,
        '@media (min-width: 1024px)': {
          margin: '1rem 0',
        }
      },
      '.picture': {
        height: 210,
      },
      '&--desc': {
        transform: 'none',
        marginTop: '1rem',
      },
      '&--picture': {
        height: 'auto',
        maxWidth: 'calc(100% - 1.5rem)',
        marginLeft: '1.5rem',
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(100% - 2.5rem)',
          marginLeft: '2.5rem',
        },
      }
    },

    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/3 * 100%)',
      flexBasis: 'calc(1/3 * 100%)',
      margin: '1rem 0px',
    },
    '&-inner':{
      position:'relative',
      '@media (min-width: 1024px)': {
        padding: '0px 2rem',
      },
    },
    '&:nth-child(3n)': {
      '@media (min-width: 1024px)': {
        marginTop: '6rem',
      },
    },
    '&:nth-child(3n - 1)': {
      marginTop: '3rem',
    },
    '&:first-child': {
      maxWidth: '100%',
      flexBasis: '100%',
      padding: 0,
      marginTop: 0,
      marginBottom: '4rem',
      '@media (min-width: 1024px)': {
        // marginBottom: '4rem',
      },
      '.picture' : {
        '@media (min-width: 1024px)': {
          height: 420, 
        }
      },
      '.gift-number': {
        transform: 'translate(-10px, -60%)',
      //   '@media (min-width: 1024px)': {
      //     transform: 'translate(3.5vw, -8rem)',
      //   }
      },
    },
    '&:nth-child(2)': {
      maxWidth: '100%',
      flexBasis: '100%',
      marginTop: 0,
      '@media (min-width: 1024px)':{
        maxWidth: '50%',
        flexBasis: '50%',
      },
      '.picture' : {
        height: 260,
        '@media (min-width: 1024px)': {
          height: 320,
        }
      }
    },
    '&:nth-child(3)': {
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)':{
        maxWidth: '50%',
        flexBasis: '50%',
      },
      '.picture' : {
        height: 260,
        '@media (min-width: 1024px)': {
          height: 320,
        }
      }
    },
    '&-number': {
      color: Colors.extraLightGrey,
      position: 'absolute',
      top: 0,
      left: 0,
      fontWeight:  'bold',
      fontSize: '6.5rem',
      transform: 'translate(-10%, -65%)',
      '@media (min-width: 1024px)': {
        fontSize: '9.375rem',
      },
      'sup': {
        fontSize: '2.5rem',

        '@media (min-width: 1024px)': {
          fontSize: '3.75rem',
        }
      }
    },
    '&.highlight': {
      '.gift': {
        '&-number': {
          color: Colors.red,
        }
      }
    },
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/gift.js